import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { Button, Col, Flex, Form, Input, Row, Typography } from "antd";

import QuestionContent from "./QuestionContent";

export default function RenderInput(props) {
	const {
		namePath = [],
		form_question_options = [],
		required = false,
		inputType = "text",
		question = null,
		description = null,
		add_another = false,
	} = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;
	const [inputs, setInputs] = useState(add_another ? [{ id: 0 }] : []);

	const handleAddAnother = () => {
		setInputs((prev) => [...prev, { id: prev.length }]);
	};

	const hasValue = (value) => {
		if (value === 0) {
			return true;
		}

		if (typeof value === "string") {
			return value.trim() !== "";
		}

		return value !== undefined && value !== null && value !== "";
	};

	if (add_another) {
		return (
			<>
				{(question || description) && (
					<Row>
						<Col xs={24} sm={24} md={24} lg={24} xl={24}>
							{question && (
								<div
									className="quill-output question"
									dangerouslySetInnerHTML={{
										__html: question,
									}}
								/>
							)}
							{description && <div className="description">{description}</div>}
						</Col>
					</Row>
				)}

				{inputs.map((input, idx) => (
					<Row key={`input_set_${input.id}`} style={{ marginBottom: 16 }}>
						<Col xs={24} sm={24} md={24} lg={24} xl={24}>
							<Form.Item
								name={`${newNamePath}_set_${idx}`}
								rules={[
									{
										required: required ? true : false,
										message: "This field is required!",
									},
								]}
							>
								<Input placeholder="Answer" size="large" type={inputType} />
							</Form.Item>
						</Col>

						<Form.Item shouldUpdate noStyle>
							{({ getFieldValue }) => {
								const setFieldName = `${newNamePath}_set_${idx}`;
								const setFieldValue = getFieldValue(setFieldName);

								if (!hasValue(setFieldValue)) {
									return null;
								}

								return (
									<Col
										xs={24}
										sm={24}
										md={24}
										lg={24}
										xl={24}
										style={{ paddingLeft: 12 }}
									>
										{form_question_options
											.filter((option) => !option.is_other)
											.map((option) => (
												<Row
													key={`${setFieldName}_qo_${option.id}`}
													style={{ marginBottom: 12 }}
												>
													<Col xs={24}>
														{option.sub_option_type ? (
															<QuestionContent
																namePath={`${setFieldName}_qo_${option.id}`}
																question={
																	option.question_option || option.option
																}
																type={option.sub_option_type}
																required={option.required ? true : false}
																max_checkbox={option.max_checkbox || 0}
																escape_questions={
																	option.escape_questions || []
																}
																form_question_options={
																	option.form_question_options || []
																}
															/>
														) : (
															<>
																<Flex align="center">
																	<Typography.Text strong>
																		{option.option}
																	</Typography.Text>
																</Flex>
																<Form.Item
																	name={`${setFieldName}_qo_${option.id}`}
																	rules={[
																		{
																			required:
																				option.required ||
																				option.option_required
																					? true
																					: false,
																			message: "This field is required!",
																		},
																	]}
																>
																	<Input
																		placeholder="Answer"
																		size="large"
																		type={inputType}
																	/>
																</Form.Item>
															</>
														)}
													</Col>
												</Row>
											))}
									</Col>
								);
							}}
						</Form.Item>
					</Row>
				))}

				<Row>
					<Col xs={24} sm={24} md={24} lg={24} xl={24}>
						<Button
							type="link"
							className="w-auto h-auto p-0"
							icon={<FontAwesomeIcon icon={faPlus} />}
							onClick={handleAddAnother}
						>
							Add Another
						</Button>
					</Col>
				</Row>
			</>
		);
	}

	return (
		<Row>
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<div
					className="quill-output question"
					dangerouslySetInnerHTML={{
						__html: question,
					}}
				/>
				{description && <div className="description">{description}</div>}
			</Col>

			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<Form.Item
					name={newNamePath}
					rules={[
						{
							required: required ? true : false,
							message: "This field is required!",
						},
					]}
				>
					<Input placeholder="Answer" size="large" type={inputType} />
				</Form.Item>
			</Col>
		</Row>
	);
}

